import { Menu, Layout, Avatar, Radio, Space } from 'antd'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import classNames from 'classnames'
import { NavLink, useHistory, useLocation } from 'react-router-dom'
import _ from 'lodash'
import ButtonWhite from 'components/design/Form/ButtonWhite'
import UpgradePlanCard from '../UpgradePlanCard'
import style from './style.module.scss'
import '../appNavMenu/index.css'

const { Sider } = Layout

const AppNavMenuFooter = () => {
  const [openKeys, setOpenKeys] = useState([''])
  const history = useHistory()

  const location = useLocation()
  const onOpenChange = keys => {
    setOpenKeys(keys.length ? [keys[keys.length - 1]] : [''])
  }
  const onSelect = keys => {
    if (_.includes(['item_0', 'item_6', 'item_7'], keys.key)) setOpenKeys([])
  }
  const apps = useSelector(state => state.apps)

  const othertwoApps = _.chain(apps.data)
    .reject({ id: apps.active.id }) // Exclude items where id = "current"
    .take(2) // Take the first two elements
    .value()

  const onChange = e => {
    if (apps.active.id !== e.target.value) {
      history.push(`/app/${e.target.value}/overview`)
      window.location.reload()
    }
  }

  const handleAppListItemHover = () => {}

  const handleAppListItemClick = (id, clickable) => {
    if (clickable) {
      history.push(`/app/${id}/overview`)
      window.location.reload()
    }
  }

  const isAgentConfigMode =
    location.pathname.includes('/ai-agents/') && location.pathname.split('/').length > 5

  // Check if we should show agent config menu
  if (isAgentConfigMode) {
    return (
      <Sider
        width={208}
        className={classNames('site-layout-background', style.appNavMenuFooterCustomWrapper)}
      >
        <UpgradePlanCard />
        <ButtonWhite
          onClick={() => {
            history.push(`/app/${apps.active.id}/ai-agents`)
          }}
          buttonText="Go to Dashboard"
          htmlType="button"
        />
      </Sider>
    )
  }

  return (
    <Sider
      width={208}
      className={classNames('site-layout-background', style.appNavMenuFooterCustomWrapper)}
    >
      <Menu
        className={style.appNavMenuFooterCustom}
        mode="vertical"
        openKeys={openKeys}
        onOpenChange={onOpenChange}
        onSelect={onSelect}
      >
        {/* APPS */}
        <Menu.SubMenu
          key="apps"
          popupOffset={othertwoApps.length ? [0, -210] : [0, -100]}
          className={classNames(
            style.appNavMenuCustomSubMenu,
            style.appNavSubMenuCustomAppListButton,
            'appInfoMenu',
          )}
          title={
            <div
              className={classNames(style.appNavSubMenuCustomTitle)}
              style={{
                backgroundColor: '#fffff',
                padding: '16px',
                borderRadius: '8px',
              }}
            >
              <Avatar
                style={{
                  backgroundColor: '#F5F5F5', // Customize the background color
                  color: '#727272', // Customize the text color
                  fontSize: '16px', // Adjust font size
                  display: 'flex', // Ensure alignment
                  justifyContent: 'center', // Center text horizontally
                  alignItems: 'center', // Center text vertically
                  minWidth: '40px', // Set square dimensions
                  minHeight: '40px',
                  borderRadius: '9999px', // No rounded corners for square
                }}
              >
                {apps.active.name ? apps.active.name.match(/[A-Za-z]/)?.[0].toUpperCase() : ''}
              </Avatar>
              <div>
                <div
                  style={{
                    fontSize: '14px',
                    fontWeight: 600,
                    height: '20px',
                    color: '#181D27',
                    fontFamily: 'Satoshi',
                  }}
                >
                  {apps.active.name && apps.active.name.length > 14
                    ? `${apps.active.name.slice(0, 14)}...`
                    : apps.active.name}
                </div>
                <div
                  style={{
                    fontSize: '14px',
                    fontWeight: 400,
                    color: '#717680',
                    fontFamily: 'Satoshi',
                  }}
                >
                  {apps.active.id}
                </div>
              </div>
            </div>
          }
        >
          <Radio.Group
            style={{
              backgroundColor: '#fff',
            }}
            onChange={onChange}
            value={apps.active.id}
          >
            <Space direction="vertical" style={{ backgroundColor: '#fff' }}>
              <Radio
                style={{
                  height: 'fit-content',
                  display: 'flex',
                  flexDirection: 'row-reverse',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  gap: '8px',
                  width: '100%',
                  paddingRight: '16px',
                  paddingLeft: '10px',
                }}
                value={apps.active.id}
                className={style.appNavRadioGroup}
              >
                <Menu.Item
                  className={classNames(
                    style.appNavMenuCustomItem,
                    style.appNavMenuCustomItemChild,
                    style.appNavMenuCustomItemFooter,
                  )}
                  style={{ cursor: 'default', height: '50px', paddingInline: '0px' }}
                  onItemHover={handleAppListItemHover}
                  onClick={() => handleAppListItemClick(apps.active.id, false)}
                  itemKey={apps.active.id}
                  key={apps.active.id}
                >
                  <div
                    className={classNames(
                      style.appNavMenuResourcesWrapper,
                      style.appNavMenuAppsWrapperName,
                    )}
                  >
                    <Avatar
                      style={{
                        backgroundColor: '#F5F5F5', // Customize the background color
                        color: '#727272', // Customize the text color
                        fontSize: '16px', // Adjust font size
                        padding: '16px',
                        display: 'flex', // Ensure alignment
                        justifyContent: 'center', // Center text horizontally
                        alignItems: 'center', // Center text vertically
                        width: '32px', // Set square dimensions
                        height: '32px',
                        borderRadius: '8px', // No rounded corners for square
                      }}
                    >
                      {apps.active.name
                        ? apps.active.name.match(/[A-Za-z]/)?.[0].toUpperCase()
                        : ''}
                    </Avatar>
                    <div>
                      <div
                        style={{
                          fontSize: '12px',
                          fontWeight: 500,
                          height: '16px',
                          color: '#141414',
                        }}
                      >
                        {apps.active.name && apps.active.name.length > 19
                          ? `${apps.active.name.slice(0, 19)}...`
                          : apps.active.name}
                      </div>
                      <div
                        style={{
                          fontSize: '12px',
                          fontWeight: 400,
                          color: '#727272',
                          fontFamily: 'SatoshiRegular',
                        }}
                      >
                        {apps.active.id}
                      </div>
                    </div>
                  </div>
                </Menu.Item>
              </Radio>
              {othertwoApps.map(item => (
                <Radio
                  value={item.id}
                  style={{
                    height: 'fit-content',
                    display: 'flex',
                    flexDirection: 'row-reverse',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: '8px',
                    width: '100%',
                    paddingRight: '16px',
                    paddingLeft: '10px',
                  }}
                  className={style.appNavRadioGroup}
                >
                  <Menu.Item
                    className={classNames(
                      style.appNavMenuCustomItem,
                      style.appNavMenuCustomItemChild,
                      style.appNavMenuCustomItemFooter,
                    )}
                    style={{ height: '50px', paddingInline: '0px' }}
                    onItemHover={handleAppListItemHover}
                    onClick={() => handleAppListItemClick(item.id, true)}
                    itemKey={item.id}
                    key={item.id}
                  >
                    <NavLink to={`/app/${item.id}/overview`} style={{ marginBottom: '0px' }} exact>
                      <div
                        className={classNames(
                          style.appNavMenuResourcesWrapper,
                          style.appNavMenuAppsWrapperName,
                        )}
                      >
                        <Avatar
                          style={{
                            backgroundColor: '#F5F5F5', // Customize the background color
                            color: '#727272', // Customize the text color
                            fontSize: '16px', // Adjust font size
                            padding: '16px',
                            display: 'flex', // Ensure alignment
                            justifyContent: 'center', // Center text horizontally
                            alignItems: 'center', // Center text vertically
                            width: '32px', // Set square dimensions
                            height: '32px',
                            borderRadius: '8px', // No rounded corners for square
                          }}
                        >
                          {item.name ? item.name.match(/[A-Za-z]/)?.[0].toUpperCase() : ''}
                        </Avatar>
                        <div>
                          <div
                            style={{
                              fontSize: '12px',
                              fontWeight: 500,
                              height: '16px',
                              color: '#141414',
                            }}
                          >
                            {item.name && item.name.length > 19
                              ? `${item.name.slice(0, 19)}...`
                              : item.name}
                          </div>
                          <div
                            style={{
                              fontSize: '12px',
                              fontWeight: 400,
                              color: '#727272',
                              fontFamily: 'SatoshiRegular',
                            }}
                          >
                            {item.id}
                          </div>
                        </div>
                      </div>
                    </NavLink>
                  </Menu.Item>
                </Radio>
              ))}
            </Space>
          </Radio.Group>

          <Menu.Item
            className={classNames(
              style.appNavMenuCustomItem,
              style.appNavMenuCustomItemChild,
              style.appNavMenuCustomItemFooter,
            )}
            style={{
              backgroundColor: '#FFF',
              width: '100%',
              margin: '0px',
              padding: '20px',
            }}
          >
            <NavLink to="/apps" style={{ marginBottom: '0px' }} exact>
              {' '}
              <div
                className={style.appNavMenuResourcesWrapper}
                style={{ color: '#6852D6', fontSize: '14px' }}
              >
                <div style={{ color: '#6852D6' }}>See All</div>
              </div>
            </NavLink>
          </Menu.Item>
          <Menu.Item
            className={classNames(
              style.appNavMenuCustomItem,
              style.appNavMenuCustomItemChild,
              style.appNavMenuCustomItemFooter,
            )}
            style={{
              borderTop: '1px solid #e7e7e7',
              backgroundColor: '#FFF',
              margin: '0px',
              width: '100%',
              padding: '20px',
            }}
          >
            <NavLink to="/create-application" style={{ marginBottom: '0px' }} exact>
              {' '}
              <div className={style.appNavMenuResourcesWrapper}>
                <img src="/resources/images/v2-dashboard/plus-circle-icon.svg" alt="icon plus" />
                <div>Create an app</div>
              </div>
            </NavLink>
          </Menu.Item>
        </Menu.SubMenu>
      </Menu>
    </Sider>
  )
}

export default AppNavMenuFooter
